/**
 * Home router
 * 
 */

import React from 'react';

// Functions

import Helpers from '../../utils/functions/helpers';

// Layout

import Article from '../layout/article/article';
import Hero from '../layout/hero/hero';
import Theme from '../layout/theme/theme';

// Components

import Button from '../../components/button/button';
import Image from '../../components/image/image';
import Meta from '../../components/meta/meta';
import Sections from '../../components/sections/sections';

// Pages

import NotFound from './404';
import Loading from './loading';

export default class Home extends React.Component {

	state = {

		doc: null,
		settings: null,
		notFound: false,
	}

	componentWillMount() {

		this.fetchPage(this.props);
	}

	componentWillReceiveProps(props) {

		this.fetchPage(props);
	}

	componentDidUpdate(prevProps) {
		
		if (this.props.location !== prevProps.location) {

			window.scrollTo(0, 0)
		}
	}

	fetchPage(props) {
		
		if (props.settings != null) {

			const { settings } = props;
			const url = props.match.params.uid === undefined ? 'home' : props.match.params.uid;

			return props.cms.api.getByUID('home', url, {}, (err, doc) => {

				if (doc) {

					// Renaming object keys to support scalable templates
					Helpers.renameObjectKeys(doc.data.body);
					
					this.setState({ doc: doc, settings: settings });
				}
				else {

					this.setState({ notFound: !doc });
				}
			});
		}

		return null;
	}

	render() {
		
		if (this.state.doc) {
			
			const { data } = this.state.doc;
			const { settings } = this.state;
						
			return (

				<React.Fragment>

					<Meta data={data} settings={settings}></Meta>
					<Theme theme={data.theme_class}></Theme>
					
					<Article layout="full">

						<Hero>
							<div className="hero-content">
								{ !! data.hero_title && <h1>{data.hero_title}</h1> }
								{ !! data.hero_link && <Button url={data.hero_link} label={data.hero_link_label} color="primary-light" /> }
							</div>
							<div className="hero-graphic"><Image data={data.hero_image}/></div>
						</Hero>

						<Sections data={data}></Sections>
						
					</Article>
				
				</React.Fragment>
			);
		}
		else if (this.state.notFound) {

			return <NotFound />;
		}

    	return <Loading />;
    }
}



// WEBPACK FOOTER //
// ./src/containers/pages/home.js